import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api';

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [token, setToken]     = useState('');
  const [newPw, setNewPw]     = useState('');
  const [newPw2, setNewPw2]   = useState('');
  const [error, setError]     = useState('');
  const [msg, setMsg]         = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tok = params.get('token');
    if (tok) setToken(tok);
    else setError(t('reset.invalidResetLink'));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPw.length < 6) return setError(t('reset.tooShort'));
    if (newPw !== newPw2) return setError(t('reset.mismatch'));
    setLoading(true);
    try {
      await api.resetPassword(token, newPw);
      setMsg(t('reset.success'));
      setTimeout(() => nav('/'), 2500);
    } catch (err) {
      setError(err.message || t('reset.invalidLink'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6">
      <span className="text-5xl mb-4">🔑</span>
      <h1 className="text-xl font-bold mb-1">{t('reset.title')}</h1>
      <p className="text-slate-400 text-sm mb-6">{t('reset.desc')}</p>

      <form onSubmit={submit} className="w-full max-w-xs space-y-3">
        <input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} required
          className="w-full bg-slate-700 rounded-xl px-4 py-3 text-white outline-none border border-slate-600 focus:border-blue-500"
          placeholder={t('reset.placeholderNew')} autoComplete="new-password" autoFocus />
        <input type="password" value={newPw2} onChange={e => setNewPw2(e.target.value)} required
          className="w-full bg-slate-700 rounded-xl px-4 py-3 text-white outline-none border border-slate-600 focus:border-blue-500"
          placeholder={t('reset.placeholderRepeat')} autoComplete="new-password" />

        {error && <p className="text-red-400 text-sm text-center">{error}</p>}
        {msg   && <p className="text-green-400 text-sm text-center">{msg}</p>}

        <button type="submit" disabled={loading || !token}
          className="w-full py-3 bg-blue-600 rounded-xl text-white font-semibold disabled:opacity-50">
          {loading ? t('reset.saving') : t('reset.save')}
        </button>
      </form>
    </div>
  );
}
